import React from "react";
import "./index.scss";
import tickIcon from "../../../Assests/Images/tickShape.svg";
import checkIcon from "../../../Assests/Images/check.svg";

const PasswordRequirements = ({
  formik,
  isDiffrentUserName,
  ispasswordInvalid,
}) => {
  return (
    <div className="passsword-points p-3">
      <p className="m-0 header">Your password must have:</p>
      <div
        className={`my-1 d-flex align-items-start gap-1 ${
          formik.values.password?.length >= 0
            ? ispasswordInvalid
              ? "error-point-one"
              : formik.values.password?.length > 7 && !ispasswordInvalid
              ? "valid-point"
              : ""
            : ""
        }`}
      >
        {formik.values.password?.length > 7 && !ispasswordInvalid ? (
          <img src={checkIcon} alt="checkIcon" width={12} height={12} />
        ) : (
          <img
            src={tickIcon}
            alt="tickIcon"
            width={12}
            height={12}
            className={`${
              formik.values.password?.length >= 0
                ? ispasswordInvalid
                  ? "error-icon"
                  : ""
                : ""
            }`}
          />
        )}
        <p>
          Must contain at least 8 characters, one uppercase letter, one
          lowercase letter, one digit, one special character (!@#$%^&*){" "}
        </p>
      </div>
      <div
        className={`my-1 d-flex align-items-start gap-1 ${
          formik.values.password?.length >= 0
            ? isDiffrentUserName
              ? "error-point-two"
              : formik.values.password?.length > 7 && !isDiffrentUserName ?"valid-point" : ""
            : ""
        }`}
      >
        {formik.values.password?.length > 7 && !isDiffrentUserName ? (
          <img src={checkIcon} alt="checkIcon" width={12} height={12} />
        ) : (
          <img
            src={tickIcon}
            alt="logo"
            width={12}
            height={12}
            className={`${
              formik.values.password?.length >= 0
                ? isDiffrentUserName
                  ? "error-icon"
                  : ""
                : ""
            }`}
          />
        )}
        <p>Must not be the same as the username</p>
      </div>
    </div>
  );
};

export default PasswordRequirements;
